import { ContainerCutter } from './types';
import { WebmClusterCutter } from './webmClusterCutter';

/**
 * Cutter lookup for Strategy B (one continuous recorder + byte cutting). A
 * mime type with no cutter falls back to the container-agnostic
 * RotatingOverlapSource (Strategy A) — never to a guessed cut.
 */
export function createCutterForMimeType(
  mimeType: string
): ContainerCutter | null {
  if (mimeType.startsWith('audio/webm')) {
    return new WebmClusterCutter();
  }
  return null;
}
